import { mode as modeWatcher } from 'mode-watcher';
import { derived } from 'svelte/store';

export const bookDemoState = $state({ open: false }); // https://stackoverflow.com/questions/79296004/bind-to-imported-state-in-svelte5-error-constant-binding
export const bookDemo = () => {
	bookDemoState.open = true;
};

let defaultMode: 'system' | 'light' | 'dark';

export const setSsrDefaultMode = (m: typeof defaultMode) => {
	defaultMode = m;
};

export const mode = derived(modeWatcher, ($modeWatcher) => {
	if (typeof document !== 'undefined') {
		return $modeWatcher;
	} else {
		return defaultMode;
	}
});
